<div class="OutsideContainer Flexbox Flexbox--column" #Container>
  <div class="FormContainer Grid Gap--smaller" #FormContainerEl>
    <ng-container *ngFor="let group of groupsToShow(); let i = index; trackBy: trackGroup">
      <mat-card #FormCard
                [class.Selected]="this.selectedGroup()?.id === group.id"
                [class.Unavailable]="isGroupUnavailable(group)">
        <mat-card-content>
          <button mat-flat-button (click)="selectGroup(group)">
            <div class="Flexbox Flexbox--column ButtonContent Gap--smaller">
              <div class="ImageContainer">
                <img [src]="getGroupImageURL(group)">
              </div>
              <div class="Flexbox ButtonName">
                <span>{{ group.displayName }}</span>
              </div>
            </div>
          </button>
        </mat-card-content>
      </mat-card>

      <!--
        🛑 EMITTED AFTER THE LAST CARD ON THE SELECTED CARD'S ROW — NOT AFTER THE SELECTED CARD.
        A full-width row inserted mid-row pushes the neighbouring card onto the next line, which
        reads as the grid reflowing whenever you pick a card in column 1. selectorAfterIndex()
        computes the row's last index from the grid's MEASURED column count, so the row stays
        intact and the selector lands underneath it.

        Two earlier placements were each measured 0% VISIBLE, for different reasons:
          inside mat-card — clipped by a fixed 138x138 tile with overflow:hidden. Failed always.
          after the grid  — below the scroll viewport. Passed at 2 cards, failed at 11.

        R2: only for the selected group, and only when it has two or more VISIBLE members —
        weightOptions() returns [] otherwise, so a group whose lightweight variant is unavailable
        at this configuration shows a card and no selector.
      -->
      <div class="WeightSelector"
           *ngIf="selectorAfterIndex() === i && weightOptions().length > 0"
           [style.grid-template-columns]="'repeat(' + gridColumns() + ', minmax(0, 1fr))'">
        <!--
          🛑 NO <mat-label>, SO THE ACCESSIBLE NAME MUST COME FROM aria-label — AND IT NAMES THE
          GROUP. Removing the visible label removes the control's accessible name with it: a screen
          reader would otherwise announce only "combobox, Lightweight", which says nothing about
          what is being chosen or for which profile. `weightAriaLabel()` resolves to e.g.
          "Weight for Bevel Edge profile", so the relationship to the selected card is spoken, not
          merely implied by proximity on screen. Sighted users get that association from layout;
          this is the same information for everyone else.
          Each option also carries its own aria-label, because "Standard" alone does not say
          standard WHAT, and a disabled option announces its state from the disabled attribute.
        -->
        <mat-form-field appearance="outline" class="WeightField"
                        [style.grid-column-start]="selectedColumn()">
          <!--
            ⚠ [aria-label], NOT [attr.aria-label]. MatSelect declares @Input('aria-label') and
            binds `[attr.aria-label]` on its own host from it, so an attribute binding here is
            OVERWRITTEN and the control ends up with NO accessible name. Measured 2026-09-15:
            aria-label read back as null with the attribute form, and the check that caught it was
            reading the rendered DOM, not the template.
          -->
          <mat-select [value]="selectedWeightID()" (valueChange)="selectWeight($event)"
                      [aria-label]="weightAriaLabel()"
                      panelClass="WeightSelectPanel">
            <mat-option *ngFor="let option of weightOptions()"
                        [value]="option.weight?.id ?? option.member.formWeightID"
                        [disabled]="!option.isSelectable"
                        [attr.aria-label]="option.label + ' weight' + (option.isSelectable ? '' : ', unavailable in this configuration')">
              {{ option.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </ng-container>
  </div>
</div>
